(() => {
  'use strict';
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('[data-cookie-settings]');
    if (!link) return;
    event.preventDefault();
    const status = document.getElementById(link.getAttribute('aria-describedby'));
    const cmp = window.Cookiebot;
    if (!cmp || typeof cmp.renew !== 'function') {
      if (status) {
        status.textContent = status.dataset.cookieSettingsStatus;
        status.hidden = false;
      }
      return;
    }
    if (status) {
      status.textContent = '';
      status.hidden = true;
    }
    cmp.renew();
  }, true);
})();
